import React, { useState, useEffect } from 'react';

import { Toast } from '../../components/common/Toast';
import SettingInfo from './components/SettingInfo';
import DisclaimerScreen from './components/DisclaimerScreen';


const Settings = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const disclaimerAccepted = LEGAL_PAGES?.status;

    if (disclaimerAccepted === '1') {
      setAcceptedDisclaimer(true);
    } else {
      setShowDisclaimer(true);
    }

    setIsLoading(false);
  }, []);

  const handleDisclaimerAccept = async () => {
    setSubmitting(true);
    adl_legal_pages__modal(true)

    try {
      const response = await fetch(`${LEGAL_PAGES.apiUrl}/accept`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': window.LEGAL_PAGES.nonce,
        },
      });

      const result = await response.json();

      if (result.success) {
        setAcceptedDisclaimer(true);
        setShowDisclaimer(false);
        Toast.success('Disclaimer accepted successfully!');
      } else {
        Toast.error('Failed to save disclaimer acceptance.');
      }
    } catch (error) {
      console.error(error);
      Toast.error('An error occurred. Please try again.');
    } finally {
      setSubmitting(false);
      adl_legal_pages__modal(false)
    }
  };

  if (showDisclaimer) {
    return (
      <DisclaimerScreen
        onAccept={handleDisclaimerAccept}
        isSubmitting={submitting}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    );
  }

  if (acceptedDisclaimer) {
    return (
      <SettingInfo
        setIsLoading={setIsLoading}
        isLoading={isLoading}
      />
    );
  }

  return null;
};

export default Settings;
